const AgentSearchPopperStyles = {
  popperContainer: {
    zIndex: 1200,
    width: "41%",
    position: "absolute",
    top: "17%",
    left: "34%",
  },
  paper: {
    background: "linear-gradient(to bottom, #ffffff, #f8f9fa)",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    overflow: "hidden",
    width: "100%",
  },
  scrollContainer: {
    maxHeight: "25rem",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "4px",
      "&:hover": {
        background: "#666",
      },
    },
  },
  noRecordsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  noRecordsText: {
    marginTop: "10%",
    marginBottom: "10%",
    fontSize: "16px",
    fontWeight: "500",
    color: "#333",
    textAlign: "center",
  },
  refineText: {
    mt: 2,
    textAlign: "center",
    fontSize: "16px",
  },
};

export default AgentSearchPopperStyles;
